import { ActionTypes } from '../types/actionTypes';

export interface IPurchase {
  buyer: { inn: string; kpp: string; short_name: string; name: string };
  is_msp: boolean;
  is_winner: boolean;
  nmc: string;
  okpd2_codes: string[];
  published_at: string;
  regions: string[];
  short_title: string;
  source: string;
  title: string;
  url: string;
  complaints: {
    [key: string]: any;
  };
}

interface IPurchasingHistoryState {
  data: any;
  tags: string[];
  isLoading: boolean;
  inn: string;
  errors: string;
  data_contracts: any;
  data_complaints: any;
}

export interface ISetPurchasingHistory {
  type: typeof ActionTypes.SET_PURCHASING_HISTORY;
  payload: any;
}
export interface ISetPurchasingHistoryTags {
  type: typeof ActionTypes.SET_PURCHASING_HISTORY_TAGS;
  payload: string[];
}
export interface ISetPurchasingHistoryLoading {
  type: typeof ActionTypes.SET_PURCHASING_HISTORY_LOADING;
  payload: boolean;
}
export interface ISetPurchasingHistoryInn {
  type: typeof ActionTypes.SET_PURCHASING_HISTORY_INN;
  payload: string;
}

export interface ISetPurchasingHistoryErrors {
  type: typeof ActionTypes.SET_PURCHASING_HISTORY_ERRORS;
  payload: string;
}

export interface ISetPurchaseHistoryComplaints {
  type: typeof ActionTypes.SET_PURCHASE_HISTORY_COMPLAINTS;
  payload: string;
}
export interface ISetPurchaseHistoryContractsAggregates {
  type: typeof ActionTypes.SET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES;
  payload: string;
}

type TActionTypes =
  | ISetPurchasingHistory
  | ISetPurchasingHistoryTags
  | ISetPurchasingHistoryLoading
  | ISetPurchasingHistoryInn
  | ISetPurchasingHistoryErrors
  | ISetPurchaseHistoryComplaints
  | ISetPurchaseHistoryContractsAggregates;

export default function purchasingHistory(state = {} as IPurchasingHistoryState, action: TActionTypes) {
  switch (action.type) {
    case ActionTypes.SET_PURCHASING_HISTORY:
      return { ...state, data: { ...action.payload } };
    case ActionTypes.SET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES:
      return { ...state, data_contracts: { ...(action.payload as Object) } };

    case ActionTypes.SET_PURCHASE_HISTORY_COMPLAINTS:
      return { ...state, data_complaints: { ...(action.payload as Object) } };

    case ActionTypes.SET_PURCHASING_HISTORY_TAGS:
      return { ...state, tags: [...action.payload] };
    case ActionTypes.SET_PURCHASING_HISTORY_LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.SET_PURCHASING_HISTORY_INN:
      return { ...state, inn: action.payload };
    case ActionTypes.SET_PURCHASING_HISTORY_ERRORS:
      return { ...state, errors: action.payload };

    default:
      return state;
  }
}
